import { EPaymentType, TPaymentProcessingState } from './types';
import { TActions } from '../../../../AppModulesWrapper';
import { defaultState } from './defaultState';
import {
  UPDATE_DEPOSIT_ACCOUNT_PAYMENT,
  UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS,
  UPDATE_DEPOSIT_ACCOUNT_RECOMMENDED_PACKAGE_PAYMENT_STATUS,
} from '../../../actions/depositAccount';
import { RESET_STATE } from '../../../actions/resetState';

export const paymentProcessing = (state: TPaymentProcessingState = defaultState, action: TActions) => {
  switch (action.type) {
    case UPDATE_DEPOSIT_ACCOUNT_PAYMENT: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          type: action.payload.type,
          paymentId: action.payload.paymentId,
          provider: action.payload.provider,
          status: null,
        },
      };
    }

    case UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS: {
      return {
        ...state,
        [EPaymentType.Balance]: {
          ...state[EPaymentType.Balance]!,
          status: action.payload,
        },
      };
    }

    case UPDATE_DEPOSIT_ACCOUNT_RECOMMENDED_PACKAGE_PAYMENT_STATUS: {
      return {
        ...state,
        [EPaymentType.Package]: {
          ...state[EPaymentType.Package]!,
          status: action.payload,
        },
      };
    }

    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
};
